import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpRedisburseBatchPage } from '@/features/pcmp/pages/PcmpRedisburseBatchPage';
import { pcmpRedisburseBatchSearchSchema } from '@/features/pcmp/types/pcmpAccounts.types';

export const Route = createFileRoute('/_auth/pcmp/accounts/redisburse-batches/$batchNo/')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpRedisburseBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Re-Disbursement Batch">
      <Suspense fallback={<PageLoader />}>
        <PcmpRedisburseBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
